export function schema_fonction() {
	return {
		title: "Paramètres",
		type: "object",
		required: ["type", "code"],
		properties: {
			type: {
				type: "string",
				title: "Entrée",
				default: "line",
				enum: ["line", "file", "files"],
			},
			code: {
				type: "string",
				format: "textarea",
				options: { hidden: true },
			},
			db_requests: {
				type: "object",
				title: "Requêtes à la base de données",
				additionalProperties: {
					format: "textarea",
					type: "string"
				}
			},
			db_requests_code: {
				type: "object",
				title: "Requêtes à la base de données, avec code",
				additionalProperties: {
					type: "object",
					required: ["code", "request"],
					properties: {
						code: {
							title: "Code",
							type: "string",
							format: "javascript"
						},
						request: {
							title: "Requête",
							format: "textarea",
							type: "string"
						}
					}
				}
			},
			credentials: {
				type: "boolean",
				format: "checkbox",
				title: "Utliser les clés de sécurité"
			}
		},
	};
}
